/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idRoletaCheckin: string;
  idCorretorSistemaOrigem: string;
  codigoOpcao: string;
}

export function useMovimentarFila() {
  const putData = async (props: Props) => {
    const MOVIMENTAR_FILA = `${leadsWebEnviroment}/common/checkin/recepcao/posicao/v1`;
    const response = await instance.put(MOVIMENTAR_FILA, {
      idRoletaCheckin: props.idRoletaCheckin,
      idCorretorSistemaOrigem: props.idCorretorSistemaOrigem,
      codigoOpcao: Number(props.codigoOpcao),
    });
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: putData,
    onSuccess: () => { },
    onError: () => { },
  });

  return mutation;
}
